// extracted by mini-css-extract-plugin
module.exports = {"card":"calculatorCard_card__BR7Y6","calcHeading":"calculatorCard_calcHeading__8yiPB"};